import { propertyOf } from '../../../utils/propertyOf'
import { CrudRouter, ParamType } from '../../Routers/CrudRouter'
import { PhobsPropertiesTable } from '../Table/PhobsPropertiesTable'


export const ActivePhobsPropertiesRouter = () => {
	return (
		<CrudRouter
			ListComponent={PhobsPropertiesTable}
			additionalData={{active: true}}
			paramName={propertyOf<ParamType>('id')}
		/>
	)
}